"use client";

import React from "react";
import { ShieldCheck, CircleDollarSign, Wrench, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "Tenant Screening",
  description: "Comprehensive background, credit, and eviction checks to place reliable, high-quality tenants in your Kansas City properties.",
  icon: ShieldCheck,
  link: "/ServicesPage"
}, {
  title: "Rent Collection",
  description: "Streamlined, automated rent collection processes and detailed financial reporting to ensure consistent cash flow for investors.",
  icon: CircleDollarSign,
  link: "/services#rent-collection"
}, {
  title: "Maintenance Coordination",
  description: "24/7 responsive maintenance handling using trusted local contractors to preserve your property's value and keep tenants satisfied.",
  icon: Wrench,
  link: "/services#maintenance-coordination"
}];
export default function OurCoreManagementSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-core-management-solutions" className="bg-background py-24 lg:py-32">
      <div className="container mx-auto px-6 md:px-8 lg:px-12 max-w-7xl">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-4">
            Our Core Management Solutions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Professional, transparent, and reliable property management services designed to maximize your investment returns in the Kansas City metro area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <div key={solution.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="group h-full flex flex-col border-border hover:border-secondary transition-all duration-300 hover:-translate-y-2 hover:shadow-xl bg-card overflow-hidden">
                  <CardHeader className="pb-4 pt-8">
                    <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-lg bg-primary/5 relative">
                      {}
                      <Icon className="size-7 text-primary relative z-10" />
                      <div className="absolute -bottom-1 -right-1 size-4 rounded-full bg-secondary/80 z-0" />
                    </div>
                    <CardTitle className="text-xl font-medium text-foreground">
                      {solution.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground leading-relaxed">
                      {solution.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pb-8">
                    <Link to={solution.link} className="inline-flex items-center text-sm font-semibold text-primary hover:text-secondary transition-colors group/link">
                      Learn More
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover/link:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}